import React, {useState} from "react";
import {Route} from "react-router-dom";
import Preloader from "../components/Preloader";
import GetProcess from "../components/GetProcess";

// const PublicRoute = ({component: Component, ...rest}) => {
//     const [loaded, setLoaded] = useState(false);
//     const [processing, setProcessing] = useState(false);
//
//     // useEffect(() => {
//     // const timer = setTimeout(() => setLoaded(true), 1000);
//     // return () => clearTimeout(timer);
//     // }, []);
//
//     const openPreLoader = (function openPreLoader(){
//         setLoaded(false)
//     })
//     const closePreLoader = (function closePreLoader(){
//         setTimeout(()=>setLoaded(true), 1000)
//     })
//
//     const showProcessing = (function openProcessing(){
//         setProcessing(true)
//     })
//     const closeProcessing = (function closeProcessing(){
//         setTimeout(()=>setProcessing(false), 1000)
//     })
//
//     let history = useHistory()
//
//     return (
//         <Route
//             {...rest}
//             render={
//                 props => (
//                     <>
//                         <GetProcess show={processing}/>
//                         <Preloader show={loaded ? false : true}/>
//                         <Component
//                             {...props}
//                             openPreLoader={openPreLoader}
//                             closePreLoader={closePreLoader}
//                             showProcessing={showProcessing}
//                             closeProcessing={closeProcessing}
//                         />
//                     </>
//                 )}/>
//     );
// };
const PublicRoute = ({ component: Component, ...rest }) => {
    const [loaded, setLoaded] = useState(false);
    const [processing, setProcessing] = useState(false);

    // correct function definitions
    const openPreLoader = () => setLoaded(false);
    const closePreLoader = () => setTimeout(() => setLoaded(true), 1000);

    const showProcessing = () => setProcessing(true);
    const closeProcessing = () => setTimeout(() => setProcessing(false), 1000);

    // const history = useHistory();

    return (
        <Route
            {...rest}
            render={(props) => (
                <>
                    <GetProcess show={processing} />
                    <Preloader show={!loaded} />
                    <Component
                        {...props}
                        openPreLoader={openPreLoader}
                        closePreLoader={closePreLoader}
                        showProcessing={showProcessing}
                        closeProcessing={closeProcessing}
                    />
                </>
            )}
        />
    );
};
export default PublicRoute